import { Card } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

const headCellClass =
  "h-11 px-4 text-muted-foreground text-xs font-medium uppercase tracking-wide"
const bodyCellClass = "px-4 py-4"

export function IntakeRowSkeletonList({ count = 4 }: { count?: number }) {
  return (
    <Card className="overflow-hidden p-0">
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow className="bg-muted/40 hover:bg-muted/40">
              <TableHead className={headCellClass}>&nbsp;</TableHead>
              <TableHead className={headCellClass}>&nbsp;</TableHead>
              <TableHead className={headCellClass}>&nbsp;</TableHead>
              <TableHead className={`${headCellClass} text-right`}>&nbsp;</TableHead>
              <TableHead className={headCellClass}>&nbsp;</TableHead>
              <TableHead className={headCellClass}>&nbsp;</TableHead>
              <TableHead className={`${headCellClass} min-w-[120px]`}>&nbsp;</TableHead>
              <TableHead aria-hidden className={`${headCellClass} w-8`} />
            </TableRow>
          </TableHeader>
          <TableBody>
            {Array.from({ length: count }).map((_, i) => (
              <TableRow key={i}>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-4 w-32" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-4 w-20" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-4 w-16" />
                </TableCell>
                <TableCell className={`${bodyCellClass} text-right`}>
                  <Skeleton className="ml-auto h-4 w-20" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-4 w-24" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-4 w-28" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="h-5 w-20 rounded-full" />
                </TableCell>
                <TableCell className={bodyCellClass}>
                  <Skeleton className="size-4" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </Card>
  )
}
